module.exports = __webpack_public_path__ + "img/righticons.9be9b647.png";